import { writable } from "svelte/store";
let UserNotificationsStore;
export default UserNotificationsStore = writable([]);
